import type { AttendanceEnumsEmployeeTypeEnum } from 'generated/resources/graphql'

export enum AlertType {
  missingClockIn = 'missing_clock_in',
  missingClockOut = 'missing_clock_out',
  missingBreakTime = 'missing_break_time',
  insufficientBreakDuration = 'insufficient_break_duration',
}

export enum PopoverTypeToShow {
  Info = 'info',
  Count = 'count',
}

export const PeriodState = {
  pending: 'pending',
  approved: 'approved',
  in_progress: 'in_progress',
}

export interface NavigationParams {
  year: string
  month: string
  day: string
  periodType: string
  employeeId?: string
}

export const EMPLOYEE_TYPE: Record<'FULL_TIME' | 'PART_TIME', AttendanceEnumsEmployeeTypeEnum> = {
  FULL_TIME: 'full_time',
  PART_TIME: 'part_time',
} as const
